/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MonthlyInputs */

const cs_enum_monthly = /** @type {(inputs: Enum_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíčně`)
};

const en_enum_monthly = /** @type {(inputs: Enum_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Enum_MonthlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_monthly = /** @type {((inputs?: Enum_MonthlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MonthlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_monthly(inputs)
	return cs_enum_monthly(inputs)
});